/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetOrganizationUserSessionIssuerMigratePreflightSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetOrganizationUserSessionIssuerMigratePreflightRequest = {
  /**
   * The user_session_issuer to migrate away from.
   */
  sourceId: string;
  /**
   * The user_session_issuer to migrate onto.
   */
  targetId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetOrganizationUserSessionIssuerMigratePreflightSecurity$Outbound =
  {
    "session_header_Gram-Session"?: string | undefined;
  };

/** @internal */
export const GetOrganizationUserSessionIssuerMigratePreflightSecurity$outboundSchema:
  z.ZodMiniType<
    GetOrganizationUserSessionIssuerMigratePreflightSecurity$Outbound,
    GetOrganizationUserSessionIssuerMigratePreflightSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getOrganizationUserSessionIssuerMigratePreflightSecurityToJSON(
  getOrganizationUserSessionIssuerMigratePreflightSecurity:
    GetOrganizationUserSessionIssuerMigratePreflightSecurity,
): string {
  return JSON.stringify(
    GetOrganizationUserSessionIssuerMigratePreflightSecurity$outboundSchema
      .parse(getOrganizationUserSessionIssuerMigratePreflightSecurity),
  );
}

/** @internal */
export type GetOrganizationUserSessionIssuerMigratePreflightRequest$Outbound = {
  source_id: string;
  target_id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetOrganizationUserSessionIssuerMigratePreflightRequest$outboundSchema:
  z.ZodMiniType<
    GetOrganizationUserSessionIssuerMigratePreflightRequest$Outbound,
    GetOrganizationUserSessionIssuerMigratePreflightRequest
  > = z.pipe(
    z.object({
      sourceId: z.string(),
      targetId: z.string(),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sourceId: "source_id",
        targetId: "target_id",
        gramSession: "Gram-Session",
      });
    }),
  );

export function getOrganizationUserSessionIssuerMigratePreflightRequestToJSON(
  getOrganizationUserSessionIssuerMigratePreflightRequest:
    GetOrganizationUserSessionIssuerMigratePreflightRequest,
): string {
  return JSON.stringify(
    GetOrganizationUserSessionIssuerMigratePreflightRequest$outboundSchema
      .parse(getOrganizationUserSessionIssuerMigratePreflightRequest),
  );
}
